import * as Constants from './Constants';

const initialState = {
  nextProcessStep: '',
  previousProcessStep: '',
  allProcessStep: [],
};

function Redirection(state = initialState, action) {
  switch (action.type) {
    case Constants.NEXT_PROCESS_STEP:
      return { ...state, nextProcessStep: action.value, availablePaths: action?.availablePaths };
    case Constants.PREVIOUS_PROCESS_STEP:
      return { ...state, previousProcessStep: action.value };
    case Constants.ALL_PROCESS_STEP:
        return { ...state, allProcessStep: action.value };
    default:
      return state;
  }
}

export default Redirection;
